import { Routes } from '@angular/router';
import { provideQuizQuestionStore } from '@app/store/quiz-question';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const quizQuestionsModalRoutes: Routes = [
    {
        path: 'quiz-questions/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideQuizQuestionStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'quiz-questions/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideQuizQuestionStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'quiz-questions/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideQuizQuestionStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
